<div class="skill-taxonomy-loader" id="taxonomy-loader">
        <div class="skill-loader-box">
            <div class="loader-star">
              <i class="fa-solid fa-stars"></i>
            </div>
            <div class="plz-wait-text">
               We’re preparing your skill taxonomy
            </div>
              <div class="progress">
                  <div class="progress-bar progress-bar-animated" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style="max-width: 100%">
                  </div>
                </div>
                <div class="progressvalue">
                 {{progressValue}}% Completed
                </div>
                <div class="loader-text-on-value">
                  <p [ngClass]="{'active': (progressValue>9 && progressValue<26)}"> <i class="fa-solid fa-briefcase"></i>Scanning Job Titles</p>
                  <p [ngClass]="{'active': (progressValue>25 && progressValue<51)}"> <i class="fa-solid fa-pen-field"></i> Parsing Job Descriptions</p>
                  <p [ngClass]="{'active': (progressValue>50 && progressValue<76)}"> <i class="fa-solid fa-paintbrush-pencil"></i> Mapping Skills Requirements</p>
                  <p [ngClass]="{'active': (progressValue>75 && progressValue<100)}"> <i class="fa-solid fa-stars"></i> Building Structured Taxonomy</p>
                </div>
        </div>
    </div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
